import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import { BASE_URL } from "../../Api/constants";
import { useNavigate } from "react-router-dom";

function ReorderQuiz() {
  const [quizzes, setQuizzes] = useState([]);
  const navigate = useNavigate();

  // Fetch quizzes from the server
  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/v1/quizzes`);
        setQuizzes(response.data.data.list);
        toast.success("Quizzes fetched successfully", {
          position: "bottom-left",
        });
      } catch (error) {
        toast.error("Error fetching quizzes", { position: "bottom-left" });
      }
    };
    fetchQuizzes();
  }, []);

  // Handle the drag and drop event to reorder quizzes
  const handleOnDragEnd = async (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    // If the quiz hasn't moved, no need to do anything
    if (destination.index === source.index) {
      return;
    }

    // Reorder quizzes array
    const reorderedQuizzes = Array.from(quizzes);
    const [removed] = reorderedQuizzes.splice(source.index, 1);
    reorderedQuizzes.splice(destination.index, 0, removed);

    setQuizzes(reorderedQuizzes);

    try {
      const updatedQuizzes = reorderedQuizzes.map((quiz, index) => ({
        _id: quiz._id, // only send _id
        order: index + 1, // update the order
      }));
      await axios.post(`${BASE_URL}/api/v1/quizzes-reorder`, {
        quizzes: updatedQuizzes,
      });
      toast.success("Quizzes reordered successfully", {
        position: "bottom-left",
      });
    } catch (error) {
      toast.error("Error updating quiz order", { position: "bottom-left" });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 3,
      }}
    >
      <Typography variant="h4" sx={{ marginBottom: 3 }}>
        Reorder Quizzes
      </Typography>

      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="quizzes-list">
          {(provided) => (
            <Box
              ref={provided.innerRef}
              {...provided.droppableProps}
              sx={{ width: "100%", maxWidth: 600, padding: 2 }}
            >
              {quizzes.map((quiz, index) => (
                <Draggable key={quiz._id} draggableId={quiz._id} index={index}>
                  {(provided) => (
                    <Paper
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      sx={{
                        marginBottom: 2,
                        padding: 2,
                        cursor: "move",
                        backgroundColor: "#f9f9f9",
                        boxShadow: 3,
                      }}
                    >
                      <Typography variant="h6">{quiz.name}</Typography>
                      <Typography variant="body2">
                        {quiz.description}
                      </Typography>
                    </Paper>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>

      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(`/management-exam`)}
        sx={{ marginTop: 2 }}
      >
        Back to Quiz Management
      </Button>

      <ToastContainer />
    </Box>
  );
}

export default ReorderQuiz;
